import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';

@Injectable()
export class AgencyConfigService {
  constructor(private http: HttpClient) {}

  copyFromCompany(
    body: { source_company_id: string },
    urlParams: { company_id: string },
  ): Observable<{ copied: string[] }> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/agency_config/copy_from`,
      urlParams,
    );
    return this.http.post<{ copied: string[] }>(url, body);
  }

  /** Replace only one entity type (checklist, workflow, notification, or cron) from source company, or copy selected templates without source_company_id. */
  copyEntityFromCompany(
    body: {
      source_company_id?: string;
      entity_type: 'checklist' | 'workflow' | 'notification' | 'cron';
      checklist_agency_ids?: string[];
      workflow_agency_ids?: string[];
    },
    urlParams: { company_id: string },
  ): Observable<{ copied: string[]; count?: number }> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/agency_config/copy_entity_from`,
      urlParams,
    );
    return this.http.post<{ copied: string[]; count?: number }>(url, body);
  }

  /**
   * Agency checklist templates for the current company's agency.
   * @param sourceCompanyId optional — when set, uses legacy copy-from-company permission path
   */
  listChecklistSource(
    urlParams: { company_id: string },
    sourceCompanyId?: string | null,
  ): Observable<{ count: number; checklists: any[] }> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/agency_config/checklists_from`,
      urlParams,
    );
    let params = new HttpParams();
    if (sourceCompanyId) {
      params = params.set('source_company_id', sourceCompanyId);
    }
    return this.http.get<{ count: number; checklists: any[] }>(url, { params });
  }

  /**
   * Agency workflow templates for the current company's agency.
   */
  listWorkflowSource(
    urlParams: { company_id: string },
    sourceCompanyId?: string | null,
  ): Observable<{ count: number; workflows: any[] }> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/agency_config/workflows_from`,
      urlParams,
    );
    let params = new HttpParams();
    if (sourceCompanyId) {
      params = params.set('source_company_id', sourceCompanyId);
    }
    return this.http.get<{ count: number; workflows: any[] }>(url, { params });
  }
}
